'use strict';

/*
 * collection.js
 * Sort and filter controls shared by collection.liquid
 * and list-collections.liquid.
 */

(function () {

  // Sort select → Shopify native sort_by URL param
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // Filter panel toggle
  var filterBtn   = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.getElementById('collection-filters');
  if (filterBtn && filterPanel) {
    filterBtn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      filterPanel.classList.toggle('is-open');
    });
  }

}());
